// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3RqS9","file":"styles_file__26ULB"};